import axios from "axios";
import {BASE_PATH} from "../services/api";

export const fetchInventory = async (store_code) => {
    return axios.get(BASE_PATH + "/admin/navigator/inventory/" + store_code, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
};

export const getInventoryByStore = async (store_code) => {
    return axios.get(BASE_PATH + "/admin/get-inventory-store/" + store_code, {
        headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    });
}

